import gql from 'graphql-tag';

export const ownerFieldsFragment = gql`
  fragment AdminOwnerFields on Owner {
    objectOwnerType
    organization {
      _type
      _ref
    }
    uid
    name
  }
`;